import * as React from 'react'
import { withRouter, useLocation } from 'react-router-dom'
import { memo, useMemo } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { connect } from 'react-redux'

import Navigator from 'src/components/Navigator'

import Tabs from './components/tabs'
import Overview from './components/overview'
import AllRisks from './components/all-risks'
import MitigationTasks from './components/mitigation-tasks'
import MyRisks from './components/my-risks'

const TAB_CRUMB_TITLES = {
    overview: 'Overview',
    'all-risks': 'All Risks',
    'my-risks': 'My Risks',
    'mitigation-tasks': 'Mitigation Task',
}

const RISK_MANAGEMENT_PATH = '/admin/risk-management'

const RiskManagement = () => {
    const location = useLocation()
    const activeTab =
        new URLSearchParams(location.search).get('tab') || 'overview'

    const breadCrumbs = useMemo(() => {
        const crumbs = [
            { title: 'SIP', link: `${RISK_MANAGEMENT_PATH}?tab=overview` },
            {
                title: 'Risk Management',
                link: `${RISK_MANAGEMENT_PATH}?tab=overview`,
            },
        ]

        const tabTitle = TAB_CRUMB_TITLES[activeTab]
        if (tabTitle) {
            crumbs.push({
                title: tabTitle,
                link: '#',
            })
        }

        return crumbs
    }, [activeTab])

    const renderContent = () => {
        const searchParams = new URLSearchParams(location.search)

        let result = null

        switch (searchParams.get('tab')) {
            case 'overview':
                result = <Overview />
                break
            case 'all-risks':
                result = <AllRisks />
                break
            case 'my-risks':
                result = <MyRisks />
                break
            case 'mitigation-tasks':
                result = <MitigationTasks />
                break
            default:
                break
        }

        return (
            <React.Fragment>
                <Tabs />

                {result}
            </React.Fragment>
        )
    }

    return (
        <div className='page-content risk-management-module'>
            <Container fluid>
                <Row>
                    <Col lg='12' className='mb-4'>
                        <Navigator
                            pageTitle='Risk Management'
                            breadCrumbs={breadCrumbs}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg='12' className='mb-4'>
                        <div className='details-content-wrapper'>
                            {renderContent()}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login
    const { Organization } = state
    return {
        user: state.Login.user,
        token: token,
        organization: Organization
    }
}

export default withRouter(connect(mapStatetoProps, {})(memo(RiskManagement)))
